import { render, staticRenderFns } from "./research.vue?vue&type=template&id=63e18083&scoped=true"
import script from "./research.vue?vue&type=script&lang=js"
export * from "./research.vue?vue&type=script&lang=js"
import style0 from "./research.vue?vue&type=style&index=0&id=63e18083&prod&lang=less&scoped=true"
import style1 from "./research.vue?vue&type=style&index=1&id=63e18083&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63e18083",
  null
  
)

export default component.exports